/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import './Label.scss';
import InfoIcon from 'assets/icons/icon-info.svg';

const Label = ({
  isTranslate, withInfo, intl, label, onWithInfoClick, id, withLink, linkLabel, linkUrl,
}) => (
  <span className={`label ${withLink ? 'label--with-link' : ''}`}>
    {isTranslate ? intl.formatMessage({ id: label }) : label}
    {withInfo && <img src={InfoIcon} alt="More info" onClick={() => onWithInfoClick(id)} />}
    {withLink && <a href={linkUrl} alt={linkLabel} target="_blank" rel="noopener noreferrer">{linkLabel}</a> }
  </span>
);

Label.propTypes = {
  /** label id */
  id: PropTypes.node,
  /** label */
  label: PropTypes.node,
  /** translate label */
  isTranslate: PropTypes.bool,
  /** with information icon */
  withInfo: PropTypes.bool,
  /** with info event */
  onWithInfoClick: PropTypes.func,
  /** is with Link */
  withLink: PropTypes.bool,
  /** link label */
  linkLabel: PropTypes.string,
  /** link url */
  linkUrl: PropTypes.string,
};

Label.defaultProps = {
  id: null,
  label: null,
  isTranslate: false,
  withInfo: false,
  onWithInfoClick: () => {},
  withLink: false,
  linkLabel: '',
  linkUrl: '',
};

export default injectIntl(Label);
